import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { LoggingModule } from "../logging/logging.module";
import { SideNavEffects } from "./state/side-nav/side-nav.effects";
import {
  sideNavFeatureKey,
  sideNavReducer,
} from "./state/side-nav/side-nav.reducer";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    LoggingModule,
    StoreModule.forFeature(sideNavFeatureKey, sideNavReducer),
    EffectsModule.forFeature([SideNavEffects]),
  ],
})
export class SideNavModule {}
